export const HEALTH_HISTORY_ADULT_SURVEY_SYSTEM_NAME = '1';
export const HEALTH_HISTORY_PEDIATRIC_SURVEY_SYSTEM_NAME = '2';
export const ONE_MEDICAL_MEMBERSHIP_PURCHASE_PHONE_NUMBER = '888-888-6373';
